// '图片类型'
const imageTypes = [
    'IMG_ADS',
    'IMG_TO_IMG',
    'TEXT_TO_IMG',
    'IMG_REFRAME',
    'IMG_EDIT',
    'IMG_CLARITY_UPSCALER',
    'IMAGE_TRANSLATE',
    'IMAGE_FACE_SWAP',
    'IMG_REPAIR',
    'IMG_BG_CHANGE',
    'IMG_TEXT_ERASE',
    'IMAGE_EFFECT_TEMPLATE_CREATION',
    'IMG_BG_REMOVE',
    'IMAGE_EXPAND',
]

// 视频类型
const videoTypes = [
    'VIDEO_ADS',
    'IMG_TO_VIDEO',
    'TEXT_TO_VIDEO',
    'VIDEO_MAGIC',
    'VIDEO_ANIME_CONVERTER',
    'VIDEO_FACE_CHANGE',
    'VIDEO_LIPS_CHANGE',
    'VIDEO_CROP',
    'VIDEO_MERGE',
    'VIDEO_SINGLE_CHARACTER_EDIT',
    'VIDEO_EDIT',
    'VIDEO_SUBTITLE_ERASE',
    'VIDEO_SUBTITLE_GENERATE',
    'VIDEO_SUBTITLE_TRANSLATE',
    'VIDEO_UPSCALER',
    'VIDEO_UPSCALER_V3',
    'VIDEO_WATERMARK_REMOVE',
    'SORA_VIDEO_TO_VIDEO',
    'VIDEO_BACKGROUND_REMOVE',
    'VIDEO_EXTEND',
    'VIDEO_ANIME_REPLACE',
    'VIDEO_EFFECT_TEMPLATE_CREATION',
]

// 暂定 ----
// 通用/未分类枚举值数组（含空字符串）
const commonTypes = [
    '', // 空字符串默认选项
    'ADS_VARIANT',
    'DIGITAL_HUMAN',
    'HOT_TRENDS',
    'TEMPLATE_CREATION',
    'WORKFLOW_CREATION',
    'COMPETITOR_IMAGE_AD_CLONE',
    'COMPETITOR_VIDEO_AD_CLONE',
]

// 确定输出类型
export const getInspirationType = (type: string) => {
    if (imageTypes.includes(type)) {
        return 'IMAGE'
    } else if (videoTypes.includes(type)) {
        return 'VIDEO'
    } else if (commonTypes.includes(type)) {
        return 'COMMON'
    } else {
        return 'OTHER'
    }
}

export const getInspirationOutputType = (outputName: string) => {
    // 容错：空值或非字符串时直接返回
    if (!outputName || typeof outputName !== 'string') {
        return undefined
    }

    // 视频格式扩展名
    const videoExtensions = [
        '.mp4',
        '.avi',
        '.mov',
        '.wmv',
        '.flv',
        '.mkv',
        '.webm',
        '.m4v',
        '.mpg',
        '.mpeg',
        '.3gp',
        '.ogv',
        '.f4v',
        '.m2ts',
        '.mts',
        '.ts',
        '.vob',
        '.rm',
        '.rmvb',
        '.asf',
        '.divx',
    ]

    // 图片格式扩展名
    const imageExtensions = [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.bmp',
        '.webp',
        '.svg',
        '.ico',
        '.tiff',
        '.tif',
        '.heic',
        '.heif',
        '.raw',
        '.psd',
        '.ai',
        '.eps',
        '.jfif',
        '.avif',
        '.apng',
    ]

    // 转换为小写进行匹配
    const lowerOutputName = outputName.toLowerCase()

    // 检查是否包含视频扩展名
    if (videoExtensions.some(ext => lowerOutputName.includes(ext))) {
        return 'VIDEO'
    }

    // 检查是否包含图片扩展名
    if (imageExtensions.some(ext => lowerOutputName.includes(ext))) {
        return 'IMAGE'
    }

    // 默认返回 undefined 或其他值
    return undefined
}

export const formatPath = (
    path: string,
    template_id?: string,
    template_path?: string
) => {
    let navigationPath = ''
    switch (path) {
        case 'TEXT_TO_IMG':
            navigationPath = 'text-to-image'
            break
        case 'IMG_TO_IMG':
            navigationPath = 'image-to-image'
            break
        case 'TEXT_TO_VIDEO':
            navigationPath = 'text-to-video'
            break
        case 'IMG_TO_VIDEO':
            navigationPath = 'image-to-video'
            break
        case 'VIDEO_EDIT':
            navigationPath = 'video-to-video'
            break
        case 'IMG_BG_CHANGE':
            navigationPath = 'ai-background-changer'
            break
        case 'IMG_REFRAME':
            navigationPath = 'ai-image-resizer'
            break
        case 'VIDEO_EXTEND':
            navigationPath = 'ai-video-extender'
            break
        case 'IMAGE_TRANSLATE':
            navigationPath = 'image-text-translate'
            break
        case 'IMG_CLARITY_UPSCALER':
            navigationPath = 'image-upscaler'
            break
        case 'IMAGE_FACE_SWAP':
            navigationPath = 'photo-face-swap'
            break
        case 'IMG_REPAIR':
            navigationPath = 'photo-restoration'
            break
        case 'IMG_TEXT_ERASE':
            navigationPath = 'remove-text-from-image'
            break
        case 'IMAGE_EXPAND':
            navigationPath = 'ai-image-extender'
            break
        case 'IMG_BG_REMOVE':
            navigationPath = 'ai-image-background-remover'
            break
        case 'VIDEO_SUBTITLE_ERASE':
            navigationPath = 'remove-video-subtitles'
            break
        case 'VIDEO_WATERMARK_REMOVE':
            navigationPath = 'remove-video-watermark'
            break
        case 'VIDEO_SUBTITLE_TRANSLATE':
            navigationPath = 'translate-video-subtitle'
            break
        case 'VIDEO_BACKGROUND_REMOVE':
            navigationPath = 'video-background-remover'
            break
        case 'VIDEO_MAGIC':
            navigationPath = 'video-effects/ai-dancing'
            break
        case 'VIDEO_FACE_CHANGE':
            navigationPath = 'ai-tools'
            break
        case 'VIDEO_LIPS_CHANGE':
            navigationPath = 'video-lip-sync'
            break
        case 'VIDEO_ANIME_CONVERTER':
            navigationPath = 'video-to-anime'
            break
        case 'VIDEO_ANIME_REPLACE':
            navigationPath = 'video-motion-imitation'
            break
        case 'VIDEO_UPSCALER_V3':
            navigationPath = 'video-upscaler'
            break
        case 'IMAGE_EFFECT_TEMPLATE_CREATION':
            navigationPath = `photo-effects/${template_path || ''}`
            break
        case 'VIDEO_EFFECT_TEMPLATE_CREATION':
            navigationPath = `video-effects/${template_path || ''}`
            break
        case 'MUSIC_CREATION_GENERATION':
            navigationPath = 'text-to-music'
            break
        default:
            navigationPath = 'noo'
            break
    }
    return navigationPath
}

// 模型名统一
export const formatModelName = (name: string) => {
    let modelName = ''
    switch (name) {
        case 'NANO_BANANA_PRO':
            modelName = 'CHATBOT_GEMINI_3_PRO_IMAGE_PREVIEW'
            break
        case 'VEO_3':
            modelName = 'google-veo3'
            break
        case 'NANO_BANANA':
            modelName = 'GEMINI_2_5_FLASH'
            break
        case 'GOOGLE_VEO3_FAST_PREVIEW':
            modelName = 'VEO_3_FAST'
            break
        case 'sora2':
            modelName = 'SORA_2'
            break
        case 'veo3.1':
            modelName = 'VEO_3_1'
            break
        case 'SEEDANCE_1_PRO_FAST':
            modelName = 'DOUBAO_1_PRO_FAST'
            break
        default:
            modelName = name
            break
    }
    return modelName
}
